import Head from 'next/head';
import Image from 'next/legacy/image';
import Link from 'next/link';

import styles from './menuPhotos.module.css';
import {useContext, useEffect, useRef} from 'react';

import baseContext from '../store/base_context';
import axios from 'axios';
import {parseLocationInfo} from '../helpers/utils';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Mousewheel, Pagination} from 'swiper/modules';

const StoreMenuPage = ({location}) => {
  const baseCtx = useContext(baseContext);
  useEffect(() => {
    baseCtx.updateShowHeader(false);
  }, []);

  const swiperRef = useRef();

  const slidePrev = () => {
    swiperRef.current.slidePrev();
  };

  const slideNext = () => {
    swiperRef.current.slideNext();
  };

  return <>
    <Head>
      <title>{location.title}</title>
      {location.profile && location.profile.description &&
        <meta
          name='description'
          content={location.profile.description} />}
    </Head>
    {location.backgroundUrl &&
        <Image
          src={location.backgroundUrl}
          alt={location.title}
          layout={'fill'}
          objectFit={'cover'}
          className={styles.background_image} />
    }
    <div className={styles.wrapper}>
      <div
        className={styles.swiper_wrapper}>
        <div>
          <i
            onClick={slidePrev}
            className={`icon-sc-expand-down 
              ${styles.swiper_navigator_prev}`} />
        </div>
        <Swiper
          direction={'vertical'}
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
          }}
          pagination={{clickable: true}}
          mousewheel={true}
          modules={[Pagination, Mousewheel]}
          spaceBetween={50}
          style={{height: '100%', width: '90vw'}}
          loop={true}
        >
          {
            location?.menuPhotos?.map((photo, index) => (
              <SwiperSlide
                key={index}
                className={styles.swiper_slide}>
                <Link
                  href={photo.url}
                  target={'_blank'}>
                  <Image
                    src={photo.url}
                    alt={photo.url}
                    layout={'fill'}
                    objectFit={'contain'}
                  />
                </Link>
              </SwiperSlide>
            ))
          }
        </Swiper>
        <div>
          <i
            onClick={slideNext}
            className={`icon-sc-expand-down 
              ${styles.swiper_navigator_next}`} />
        </div>
      </div>
    </div>
  </>;
};

/**
 * Get API Response every time use load page
 * @param {object} context
 * @return {Promise<{}>}
 */
export async function getServerSideProps(context) {
  const {params} = context;
  const storeCode = params.storeCode;

  try {
    const API_V1 = process.env.NEXT_PUBLIC_API_V1;
    const getByStoreCodeUrl = API_V1 + `locations/store-code/${storeCode}`;
    const locationResp = await axios(getByStoreCodeUrl);
    const location = locationResp.data;
    const getLocationUrl = API_V1 +
        `locations/${location.PK.replace('LOCATION#', '')}`;
    const detailedLocationResp = await axios(getLocationUrl);
    const detailedLocation = detailedLocationResp.data;

    const parsedInfo = parseLocationInfo(detailedLocation);
    const parsedLocation = {
      ...detailedLocation,
      ...parsedInfo,
    };

    if (!location || !location.isActive) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        location: parsedLocation,
      }, // will be passed to the page component as props
    };
  } catch (e) {
    console.error('Error: ' + e);
    return {
      notFound: true,
    };
  }
}

export default StoreMenuPage;
